import React, { Component } from "react";
import { Form, Input, Modal, message } from "antd";
import isEmpty from "../validation/is-empty";

let callback;
export default class TextAreaModal extends Component {
  state = {
    input: "",
    visible: false,
  };

  constructor(props) {
    super(props);
    this.input_field = React.createRef();
  }

  open = ({ c, content }) => {
    console.log(content);
    this.setState({ visible: true, content }, () => {});

    callback = c;
  };

  render() {
    return (
      <div>
        <Modal
          title={this.props.title}
          visible={this.state.visible}
          onOk={() => {
            if (callback) {
              callback();
            }

            this.setState({ visible: true });
          }}
          onCancel={() => {
            this.setState({ visible: false });
            if (typeof this.props.onCancel === "function") {
              this.props.onCancel();
            }
          }}
        >
          <div className="flex-1 is-flex">
            <textarea
              value={this.state.content}
              readOnly
              style={{
                height: "500px",
                padding: "1rem",
                borderColor: "#c0c0c0",
                fontFamily: "monospace",
              }}
              className="flex-1"
            ></textarea>
          </div>
        </Modal>
      </div>
    );
  }
}
